import styled from 'styled-components';

import { Button as CommonButton } from '@rewardopl/react-ui/button/index.styles';

export const Button = styled(CommonButton)`
  --secondary-button-border-width: 0px;
  display: inline-block;
  background: white;
  box-shadow: none;
  color: black;

  &:hover, &:focus {
    background: #e3e3e3;
    box-shadow: none;
    color: black;
  }

  &:focus-visible {
    background: white;
    box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.6);
    color: black;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  position: relative;
  top: -1px;
  margin-right: 12px;
  vertical-align: -26%;
`;
